import { GET_DETAIL_LAPORAN_GRAFIK_GOLONGAN,GET_DETAIL_LAPORAN_GRAFIK_STATUS_PEGAWAI, GET_DETAIL_LAPORAN_GRAFIK_TINGKAT_PENDIDIKAN, GET_DETAIL_LAPORAN_GRAFIK_USIA, GET_LAPORAN_GRAFIK_GOLONGAN, GET_LAPORAN_GRAFIK_STATUS_PEGAWAI, GET_LAPORAN_GRAFIK_TINGKAT_PENDIDIKAN, GET_LAPORAN_GRAFIK_USIA, RESET_DETAIL_GRAFIK_USIA, RESET_LAPORAN_GRAFIK } from "shared/constants/ActionTypes";

const INIT_STATE = {
    usia: {
        dataGraph: [],
        total: 0,
        listPegawai: {
            results: []
        },
    },
    tingkatPendidikan: {
        dataGraph: null,
        total: 0,
        listPegawai: {
            results: []
        },
    },
    statusPegawai: {
        dataGraph: [],
        total: 0,
        listPegawai: {
            results: []
        },
    },
    golongan: {
        dataGraph: [],
        total: 0,
        listPegawai: {
            results: []
        },
    }
};

const grafikReducer = (state = INIT_STATE, action) => {
    switch (action.type) {
        case GET_LAPORAN_GRAFIK_USIA: {
            const data = [...action.payload?.result?.data]
            const expectedResult = transformDataDashboardUsia(data, 'list')

            return {
                ...state,
                usia: {
                    ...state.usia,
                    dataGraph: expectedResult,
                    total: action.payload.result.summary.total
                }
            }
        }
        case GET_DETAIL_LAPORAN_GRAFIK_USIA: {
            return {
                ...state,
                usia: {
                    ...state.usia,
                    listPegawai: action.payload
                }
            }
        }
        case GET_LAPORAN_GRAFIK_TINGKAT_PENDIDIKAN: {
            const result = action.payload.result
            return {
                ...state,
                tingkatPendidikan: {
                    ...state.tingkatPendidikan,
                    dataGraph: result,
                    total: result.total
                }
            }
        }
        case GET_DETAIL_LAPORAN_GRAFIK_TINGKAT_PENDIDIKAN: {
            return {
                ...state,
                tingkatPendidikan: {
                    ...state.tingkatPendidikan,
                    listPegawai: action.payload
                }
            }
        }
        case GET_LAPORAN_GRAFIK_STATUS_PEGAWAI: {
            const result = action.payload.result
            const temp = []

            Object.entries(result?.data).forEach(([key, value]) => {
                temp.push({
                    actualName: key,
                    name: key,
                    Jumlah: value
                })
            })
            return {
                ...state,
                statusPegawai: {
                    ...state.statusPegawai,
                    dataGraph: temp,
                    total: result?.total
                }
            }
        }
        case GET_DETAIL_LAPORAN_GRAFIK_STATUS_PEGAWAI: {
            return {
                ...state,
                statusPegawai: {
                    ...state.statusPegawai,
                    listPegawai: action.payload
                }
            }
        }
        case GET_LAPORAN_GRAFIK_GOLONGAN: {
            const result = action.payload.result
            const temp = []
            let total = 0
            let char = 65

            Object.entries(result?.data).forEach(([key, value]) => {
                total += value
                temp.push({
                    actualName: key,
                    name: String.fromCharCode(char),
                    Jumlah: value
                })
                char++
            })

            return {
                ...state,
                golongan: {
                    ...state.golongan,
                    dataGraph: temp,
                    total: result?.total
                }
            }
        }
        case GET_DETAIL_LAPORAN_GRAFIK_GOLONGAN: {
            return {
                ...state,
                golongan: {
                    ...state.golongan,
                    listPegawai: action.payload
                }
            }
        }
        case RESET_LAPORAN_GRAFIK: {
            return {
                usia: {
                    dataGraph: [],
                    total: 0,
                    listPegawai: {
                        results: []
                    },
                },
                tingkatPendidikan: {
                    dataGraph: null,
                    total: 0,
                    listPegawai: [],
                },
                statusPegawai: {
                    dataGraph: [],
                    total: 0,
                    listPegawai: [],
                },
                golongan: {
                    dataGraph: [],
                    total: 0,
                    listPegawai: [],
                }
            }
        }
        case RESET_DETAIL_GRAFIK_USIA: {
            return {
                ...state,
                usia: {
                    ...state.usia,
                    listPegawai: {
                        results: []
                    }
                }
            }
        }
        default:
            return state;
    }
};

const transformDataDashboardUsia = (data, target) => {
    if (target === 'list') {
        const filteredData = data.filter((item) => item.rentang_usia !== "Lainnya")
        return filteredData.map((item) => ({
            Pria: item.total_laki_laki,
            Wanita: item.total_perempuan,
            name: `${item.rentang_usia} Tahun`
        }))
    } else {
        const filteredData = data.filter((item) => item.pegawai__tk_pendidikan_terakhir !== null)
        return filteredData.map((item) => ({
            name: item.pegawai__tk_pendidikan_terakhir,
            Pria: item?.total_laki_laki,
            Wanita: item?.total_perempuan
        }))
    }
}

export default grafikReducer;
